import React from 'react';
import "../../../../../Assets/Styles/LoadingIndicator.scss";
import CXLoadingIconWhite from "../../../../../Assets/Images/CX_loading_icon_white.svg"
import CXLoadingCircleWhite from "../../../../../Assets/Images/CX_loading_circle_white.svg"

const ConnexingLoadingIndicatorBlue = () => {
    return (
        <div className="loading-indicator-overlay">
            <img src={CXLoadingCircleWhite} alt="CX-loading-circle" className="icon white"/>
            <img src={CXLoadingIconWhite} alt="CX-loading-icon" className="centered-icon white" />
        </div>
    );
};

export default ConnexingLoadingIndicatorBlue;
